export enum UserRole {
    SuperAdmin,
    Admin,
    Moderator,
    SuperUser,
    User,
}
